import { getContext } from '@/context';

/**
 * Checks if the miniapp is running inside the native Picsart mobile app (iOS/Android).
 * This is different from responsive mobile detection - it specifically checks
 * if the app is running in the native app context vs web browser.
 *
 * @returns true if running on iOS or Android native app, false otherwise
 */
export function isNativeMobile(): boolean {
  try {
    const ctx = getContext();
    return ctx.handlers.isIOS() || ctx.handlers.isAndroid();
  } catch {
    return false;
  }
}
